import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { legalCSS } from '../utils/legalStyles';
import { useLegalDoc } from '../utils/useLegalDoc';
import usePageMeta from '../hooks/usePageMeta';

export default function AGBPage() {
  const { t } = useLanguage();
  const { html, available, loading, error } = useLegalDoc('agb');
  usePageMeta('AGB | Lino', 'Allgemeine Geschäftsbedingungen für IT-Dienstleistungen von MakeItSimple.');

  return (
    <div style={{ minHeight: '100vh', paddingTop: '80px', paddingBottom: '80px' }}>
      <style>{legalCSS}</style>
      <div className="container">
        <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}>
          <Link to="/" className="icon-button" style={{ display: 'inline-flex', marginBottom: '32px', gap: '8px', alignItems: 'center' }}>
            <ArrowLeft size={20} />
            <span style={{ fontWeight: 500 }}>{t('nav.back')}</span>
          </Link>

          <div className="legal-content" style={{ maxWidth: '800px' }}>
            {html && html.trim() ? (
              <div dangerouslySetInnerHTML={{ __html: html }} />
            ) : loading ? (
              <p style={{ color: 'var(--text-secondary)' }}>Wird geladen…</p>
            ) : error ? (
              <p style={{ color: 'var(--text-secondary)' }}>Die AGB konnten gerade nicht geladen werden.</p>
            ) : (
              <>
                <h1>AGB</h1>
                <p style={{ color: 'var(--text-secondary)' }}>
                  {available ? 'Dieses Dokument ist noch leer.' : 'Dieses Dokument wurde noch nicht hinterlegt.'}
                </p>
              </>
            )}
          </div>
        </motion.div>
      </div>
    </div>
  );
}
